import { useState, useCallback } from "react";

import OnboardingComponent from "../components/OnboardingComponent/OnboardingComponent.js";
import OnboardingTrialComponent from "../components/OnboardingComponent/OnboardingTrialComponent.js";

const Onboarding = () => {
  const [step, setStep] = useState(0);

  const handleNextStep = useCallback(() => {
    setStep(step + 1);
  }, [step]);

  if (step === 1) {
    return <OnboardingTrialComponent />
  }

  return <OnboardingComponent onNextStep={handleNextStep} />
};

export default Onboarding;